import { PathValidityEnum } from '../../../enum/path/path-validity.enum';
import { BoPathTrjBbxInterface } from '../../../interface/back-office/path/path-trj/bo-path-trj-bbx.interface';
import { PathPoint } from './path-point';

export class PathPointBbx extends PathPoint {
  public adresse: string;
  public kms: number;
  public name: string;
  public tags: string;
  public validity: PathValidityEnum;

  constructor(o: BoPathTrjBbxInterface) {
    super(o);
    this.adresse = o.adresse;
    this.kms = parseInt(o.kms);
    this.name = o.name;
    this.tags = o.tags;
    this.validity = o.validity;
  }
}
